import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../_common/Modal';
import ModalHeader from '../_common/ModalHeader';
import SchedulerForm from './SchedulerFormContainer';
import { SchedulerModalProps } from './SchedulerModalContainer';

const SchedulerModal = React.memo((props: SchedulerModalProps) => {
  const { t } = useTranslation();
  const { closeModalScheduler, isOpen, modalSchedulerIsNew } = props;
  return (
    <Modal// `disableBackdropClick` is removed by codemod.
// You can find more details about this breaking change in [the migration guide](https://mui.com/material-ui/migration/v5-component-changes/#modal)

      isOpen={isOpen}
      onClose={closeModalScheduler}
      closeIconColor="#fff"
      maxWidth="sm">
      <ModalHeader>
        {modalSchedulerIsNew ? t('schedulerTable.newScheduler') : t('schedulerTable.editScheduler')}
      </ModalHeader>
      <SchedulerForm />
    </Modal>
  );
});

export default SchedulerModal;
